import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        const isAnonymous = currentUser == null || currentUser.token == undefined ? false : currentUser.token.isAnonymous;
        const isCurrentUser = currentUser == null || currentUser.token != undefined ? true: false;
        if (currentUser && isCurrentUser) {
            if ((currentUser.token.authenticated && !isAnonymous) || currentUser.assignors.length > 1) {
                return true;
            }
        }

        this.router.navigate(['auth'], { queryParams: { returnUrl: state.url } });
        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.canActivate(route, state);
    }
}
